import type { OpticksSvgElementProps } from "./OpticksSvgElement.types";
import "./OpticksSvgElement.css";

const getProportionalSize = (
  width: number | undefined,
  height: number | undefined,
  viewBox: string | undefined
) => {
  if (width != null && height != null) return { width, height };
  if (!viewBox) return { width, height };

  const [, , vbWidth, vbHeight] = viewBox.split(" ").map(Number);
  if (!vbWidth || !vbHeight) return { width, height };

  const aspectRatio = vbWidth / vbHeight;

  if (width != null && height == null)
    return { width, height: width / aspectRatio };
  if (height != null && width == null)
    return { width: Math.ceil(height * aspectRatio), height };

  return { width: vbWidth, height: vbHeight };
};

const OpticksSvgElement = ({
  children,
  className,
  size,
  width,
  height,
  viewBox,
  fill,
  stroke,
  strokeWidth,
  strokeLinecap,
  strokeLinejoin,
  id,
  x,
  y,
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden,
  role,
}: OpticksSvgElementProps) => {
  const proportional =
    size == null ? getProportionalSize(width, height, viewBox) : undefined;

  return (
    <svg
      className={className}
      width={size ?? proportional?.width}
      height={size ?? proportional?.height}
      viewBox={viewBox}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      id={id}
      x={x}
      y={y}
      focusable="false"
      role={role ?? (ariaLabel ? "img" : undefined)}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
    >
      {children}
    </svg>
  );
};

export default OpticksSvgElement;
